module.exports = __webpack_public_path__ + "img/touxiang.d5892e91.jpg";